/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idea_Subtitle_PrefixInputs */

const en_idea_subtitle_prefix = /** @type {(inputs: Idea_Subtitle_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn your idea into a plan your AI tools understand, or start from `)
};

const id_idea_subtitle_prefix = /** @type {(inputs: Idea_Subtitle_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubah idemu jadi rencana yang dipahami AI tools pilihanmu, atau mulai dari `)
};

/**
* | output |
* | --- |
* | "Turn your idea into a plan your AI tools understand, or start from" |
*
* @param {Idea_Subtitle_PrefixInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const idea_subtitle_prefix = /** @type {((inputs?: Idea_Subtitle_PrefixInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idea_Subtitle_PrefixInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_idea_subtitle_prefix(inputs)
	return en_idea_subtitle_prefix(inputs)
});